// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e9953774","453":"8c7b2c9b","667":"52a2e93e"}[chunkId] + ".chunk.js";
};